// Auto-generated cornerstone translation for sk.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T14:07:36.135085+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aplikácia na správu koní: najlepší výber pre rok 2026 | EquiSight",
      description: "Porovnajte aplikácie na správu koní pre majiteľov, stajne a chov. Zistite, prečo je EquiSight kompletná aplikácia pre vášho koňa.",
      keywords: [
        "aplikácia na správu koní",
        "aplikácia na správu stajne",
        "denník koní aplikácia",
        "aplikácia na správu viacerých koní",
        "aplikácia na sledovanie gravidity kobýl",
        "aplikácia pre chov koní",
        "najlepšia aplikácia na správu koní",
      ],
    },
    hero: {
      eyebrow: "Sprievodca výberom · softvér na správu koní",
      breadcrumbLabel: "Aplikácia na správu koní",
      title: "Aplikácia na správu koní: kompletný sprievodca výberom pre majiteľov, stajne a chovy.",
      intro: "Nie len zoznam funkcií — férové porovnanie, sprievodca výberom a pohľad na to, čo musí aplikácia na správu koní skutočne vedieť v roku 2026. Pre jedného koňa, celú stajňu alebo váš chov.",
      pills: [
        {
          icon: "Users",
          label: "Pre majiteľov",
        },
        {
          icon: "Building2",
          label: "Pre stajne",
        },
        {
          icon: "Baby",
          label: "Pre chovateľov",
        },
        {
          icon: "Share2",
          label: "Pre tímy",
        },
      ],
      ctas: [
        {
          label: "Začnite zadarmo s 1 koňom",
          href: "#start",
          primary: true,
        },
        {
          label: "Na porovnávaciu tabuľku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Prečo je aplikácia na správu koní čoraz dôležitejšia.",
      lead: "Správa koní je v praxi roztrieštená: WhatsApp, diár, Excel, fotky v telefóne, papierový pas, voľné faktúry a ústne dohody. Už pri jednom koni je to nepraktické. Pri viacerých koňoch, chovoch alebo zdieľanej starostlivosti vznikajú medzery, zmeškané termíny a nedorozumenia.",
      items: [
        "Kedy bolo to očkovanie?",
        "Kto zaplatil kováča?",
        "Ktorá kobyla sa má dnes skontrolovať?",
        "Prečítal si tréner pokyny z minulého týždňa?",
        "Naozaj som ten fotodokument uložil?",
        "Je kŕmny plán vyvesený v stajni stále aktuálny?",
      ],
    },
    what: {
      title: "Čo je aplikácia na správu koní?",
      lead: "Aplikácia na správu koní je v podstate digitálna karta pre každého koňa. Žiadne roztrieštené poznámky, ale jedno miesto pre zdravie, tréning, výživu, dokumenty, plánovanie, pripomienky, náklady, fotky, videá a zdieľaný prístup. Každý okolo koňa vidí rovnaké, aktuálne informácie.",
      targetGroupsTitle: "Pre koho je aplikácia na správu koní určená?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Súkromný majiteľ",
          body: "Jeden kôň, jedna karta — zdravie, plánovanie a história vždy po ruke.",
        },
        {
          icon: "Users",
          title: "Majiteľ viacerých koní",
          body: "Samostatné profily, samostatné plánovanie, zdieľaný zoznam úloh pre celý tím.",
        },
        {
          icon: "Building2",
          title: "Penzionová stajňa & jazdiarňa",
          body: "Prístup majiteľov, pokyny pre ošetrovanie, zdieľaný kalendár a úlohy.",
        },
        {
          icon: "Baby",
          title: "Chov",
          body: "Cyklus kobýl, gravidita, údaje o žrebcoch, rodokmeň a vývoj žriebät.",
        },
        {
          icon: "Target",
          title: "Tréneri",
          body: "Prehľad podľa koňa, záznamy tréningov, stanovovanie cieľov, analýza videí.",
        },
        {
          icon: "ClipboardList",
          title: "Profesionáli",
          body: "Kováč, zubár, fyzioterapeut alebo veterinár — pracujú z rovnakej karty.",
        },
      ],
    },
    criteria: {
      title: "Čo musí dobrá aplikácia na správu koní spĺňať?",
      lead: "Aplikácia nie je len pekná — musí fungovať prakticky každý deň. Päť prvkov, ktoré nesmú chýbať pri výbere v roku 2026.",
      items: [
        {
          icon: "FileText",
          title: "Karta koňa pre každého koňa",
          body: "Údaje, vek, plemeno, informácie z pasu, majiteľ, stajňa, fotky a dokumenty — všetko prepojené s jedným profilom koňa.",
        },
        {
          icon: "Heart",
          title: "Zdravie a starostlivosť",
          body: "Očkovania, odčervenie, kováč, zubár, veterinár, ošetrenia, lieky a automatické pripomienky pred termínom platnosti.",
        },
        {
          icon: "Activity",
          title: "Tréning a pokrok",
          body: "Záznamy tréningov, poznámky, videá, výsledky súťaží, ciele a pokrok podľa disciplíny alebo koňa.",
        },
        {
          icon: "Apple",
          title: "Výživa a manažment",
          body: "Kŕmne plány, doplnky, hrubá píca, váha, telesná kondícia a denná rutina, ktorú musí stajňa poznať.",
        },
        {
          icon: "Share2",
          title: "Zdieľanie s ostatnými",
          body: "Prístup pre majiteľa, ošetrovateľa, trénera, majiteľa stajne alebo profesionála — so správou práv zodpovedajúcou každej roli.",
        },
        {
          icon: "Calendar",
          title: "Plánovanie a pripomienky",
          body: "Zdieľaný kalendár s úlohami, automatickými pripomienkami a potvrdením, aby vám nič neušlo.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs iné aplikácie na správu koní.",
      lead: "Trh v súčasnosti ponúka Stalmanager, LogMyHorse, EquineM a Happie Horse. Každá má svoje silné stránky. Porovnávame najžiadanejšie funkcie vedľa seba — férovo a na základe verejne dostupných informácií.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Začať zadarmo",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Viac koní",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Zdravotná karta",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Tréning a pokrok",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Výživa a doplnky",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Plánovanie a pripomienky",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenty pre každého koňa",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Zdieľanie s tímom a správa práv",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modul chovu (kompletný)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cyklus kobýl",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Plánovanie gravidity + ultrazvuky",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vývoj žriebät",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrácia profesionálov",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Prehľady EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vhodné pre majiteľov",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Vhodné pre chov",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vhodné pre stajňu/jazdiarňu",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Porovnanie na základe verejne dostupných funkcií v januári 2026. Konkurenti sú tiež dobré nástroje; EquiSight je postavený tak, aby kombinoval všetky moduly v jednej aplikácii.",
    },
    why: {
      title: "Prečo je EquiSight iný.",
      lead: "Denník zaznamenáva. EquiSight kombinuje správu koní, tréning, výživu, zdravie, súťaže, profesionálov a chov v jednej modernej aplikácii — a ide o krok ďalej s prehľadmi.",
      points: [
        {
          icon: "Heart",
          title: "Jedna aplikácia pre celý život koňa",
          body: "Od žriebäťa po športového koňa, chovnú kobylku alebo dôchodkového koňa. Karta rastie spolu s vaším koňom — nič sa po ceste nestratí.",
        },
        {
          icon: "Sparkles",
          title: "Nielen dáta, ale aj vzory",
          body: "EquiCoach kombinuje vývoj, opakujúce sa ťažkosti, tréning a výživu — aby ste včas videli signály, nie len izolované hlásenia.",
        },
        {
          icon: "Share2",
          title: "Stvorený pre spoluprácu",
          body: "Majiteľ, správca stajne, tréner, kováč a ďalší profesionáli pracujú z rovnakej karty koňa — s právami zodpovedajúcimi ich roli.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Špeciálne · chov",
      title: "Správa koní pre chovateľov.",
      lead: "Mnohí konkurenti spomínajú chov v jednom riadku. EquiSight vytvoril kompletný modul chovu — pretože chovateľ zriedkakedy je koncovým používateľom všeobecnej aplikácie, ale plánovanie potrebuje viac ako ktokoľvek iný.",
      items: [
        "Denné sledovanie cyklu kobýl",
        "Dátum inseminácie + údaje o žrebcovi",
        "Kontrola gravidity s ultrazvukmi",
        "Očakávaný dátum narodenia žriebäťa + upozornenia",
        "Mesačný vývoj žriebäťa",
        "Rodokmeň a pôvod",
        "Poznámky pre každú kobylku",
        "Prehľad všetkých gravidných kobýl",
      ],
      ctaLabel: "Pozrite si modul chovu",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Špeciálne · stajňa & jazdiarňa",
      title: "Správa viacerých koní a penzionových stajní.",
      lead: "Pri viacerých koňoch ide menej o dáta a viac o komunikáciu. Každý majiteľ má vlastné želania, rutiny, kŕmne dohody a zdravotné poznámky. Každý zamestnanec k tomu musí mať prístup bez zdĺhavého hľadania.",
      cards: [
        {
          t: "Kone podľa majiteľa",
          d: "Každý majiteľ vidí iba svojho koňa/koní.",
        },
        {
          t: "Pokyny pre ošetrovanie",
          d: "Viditeľné pre stajňu pri každom koni.",
        },
        {
          t: "Zdieľaný kalendár",
          d: "Kováč, veterinár a súťaže v jednom prehľade.",
        },
        {
          t: "Zoznam úloh",
          d: "Prideľovanie zamestnancom s potvrdením.",
        },
        {
          t: "Prístup majiteľov",
          d: "Klienti vidia svojho koňa vo vlastnej aplikácii.",
        },
        {
          t: "Núdzové kontakty",
          d: "Vždy k dispozícii v stresových situáciách v stajni.",
        },
      ],
      ctaLabel: "Pozrite si modul jazdiarňe",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Od WhatsApp, Excelu a tabule k EquiSight.",
      lead: "Konkrétne: takto sa zmení vaša každodenná správa koní.",
      rows: [
        {
          before: "WhatsApp skupiny",
          after: "Štruktúrované poznámky pre každého koňa",
        },
        {
          before: "Excel tabuľky",
          after: "Živá karta koňa s históriou",
        },
        {
          before: "Tabuľa v stajni",
          after: "Zdieľané plánovanie v telefóne",
        },
        {
          before: "Voľné fotky v telefóne",
          after: "Médiá prepojené s vaším koňom",
        },
        {
          before: "Ústne dohody",
          after: "Úlohy a pripomienky s potvrdením",
        },
        {
          before: "Stratený papierový pas",
          after: "Dokumenty vždy po ruke",
        },
      ],
    },
    helper: {
      title: "Ktorá aplikácia na správu koní je pre vás tá pravá?",
      lead: "Odpovedzte na týchto 5 otázok a dostanete férovú odporúčanie — aj keď to nie vždy bude EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Máte jedného koňa alebo viacero koní?",
          options: [
            {
              label: "Jedného koňa",
              score: 1,
            },
            {
              label: "2–5 koní",
              score: 2,
            },
            {
              label: "Viac ako 5 koní",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Spravujete kone klientov alebo tretích strán?",
          options: [
            {
              label: "Nie, iba vlastných koní",
              score: 0,
            },
            {
              label: "Niekedy — pre rodinu alebo známych",
              score: 1,
            },
            {
              label: "Áno, profesionálne (stajňa / jazdiarňa)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Chcete sledovať chov a graviditu?",
          options: [
            {
              label: "Nie je relevantné",
              score: 0,
            },
            {
              label: "Niekedy — príležitostný chov",
              score: 1,
            },
            {
              label: "Áno, som (alebo budem) chovateľ",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Spolupracujete s trénerom, ošetrovateľom alebo profesionálom?",
          options: [
            {
              label: "Nie, všetko robím sám",
              score: 0,
            },
            {
              label: "Áno, s 1 osobou",
              score: 1,
            },
            {
              label: "Áno, s viacerými osobami",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Chcete iba zaznamenávať, alebo aj získavať prehľady?",
          options: [
            {
              label: "Iba zaznamenávať",
              score: 1,
            },
            {
              label: "Zaznamenávať + plánovanie",
              score: 2,
            },
            {
              label: "Zaznamenávať + plánovanie + prehľady",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednoduchý denník postačí — a rastie s vami.",
          body: "Pre jedného koňa bez zdieľanej starostlivosti je vhodná každá aplikácia na správu koní. EquiSight začína zadarmo s 1 koňom, takže nič neriskujete. Ak neskôr budete chcieť pridať viac koní, trénera alebo chov, všetko je už zabudované.",
          cta: "Začnite zadarmo s 1 koňom",
        },
        mid: {
          title: "EquiSight sa dobre hodí na vašu situáciu.",
          body: "Máte viacero potrieb (viac koní, spolupráca alebo prehľady). Väčšina konkurentov pokrýva 1–2 moduly; EquiSight ich kombinuje v jednej aplikácii bez nutnosti spájať samostatné nástroje.",
          cta: "Pozrite sa, čo EquiSight vie",
        },
        high: {
          title: "EquiSight je najlogickejšia voľba.",
          body: "Vaša situácia kombinuje viacero koní, spoluprácu, chov a/alebo prehľady. Práve tu EquiSight robí rozdiel — žiadne roztrieštené nástroje, ale jedna karta koňa pre všetko a každého okolo koňa.",
          cta: "Začnite zadarmo s EquiSight",
        },
      },
    },
    faqTitle: "Často kladené otázky o aplikáciách na správu koní",
    faq: [
      {
        q: "Ktorá aplikácia na správu koní je najlepšia?",
        a: "Najlepšia aplikácia na správu koní závisí od vašej situácie. Pre jednoduchý denník je vhodných viacero aplikácií. Ak chcete kombinovať zdravie, tréning, výživu, dokumenty, chov, plánovanie a spoluprácu, EquiSight je postavený ako kompletné riešenie, kde sa všetko stretáva v jednej karte.",
      },
      {
        q: "Môžem spravovať viacero koní v jednej aplikácii?",
        a: "Áno. Dobrá aplikácia na správu koní musí podporovať viacero koní vrátane majiteľov, ošetrovateľov, rutín, dokumentov, termínov a pripomienok pre každého koňa. EquiSight bol navrhnutý s týmto zámerom od prvého riadku kódu — kone sú samostatné karty, nie riadky v zozname.",
      },
      {
        q: "Je EquiSight vhodný aj pre chovateľov?",
        a: "Áno. EquiSight možno nastaviť s funkciami chovu, ako sú cyklus kobýl, dátum inseminácie, kontrola gravidity, údaje o žrebcovi, rodokmeň, očakávaný dátum narodenia žriebäťa a vývoj žriebäťa. Práve v tejto oblasti väčšina konkurenčných aplikácií ponúka len minimum alebo nič.",
      },
      {
        q: "Môžem zdieľať údaje s trénerom alebo kováčom?",
        a: "Áno. Cieľom EquiSight je, aby sa relevantné informácie dali bezpečne zdieľať s ľuďmi okolo koňa — trénerom, kováčom, zubárom, veterinárom, fyzioterapeutom, ošetrovateľom alebo majiteľom. Každá osoba dostane iba tie práva, ktoré sú potrebné pre jej rolu.",
      },
      {
        q: "Prečo nepoužívať jednoducho WhatsApp alebo Excel?",
        a: "WhatsApp a Excel fungujú, kým je všetko jednoduché. Akonáhle máte viacero koní, termínov, dokumentov, ošetrení, majiteľov alebo chovateľských údajov, stáva sa to náchylným na chyby: informácie sa roztrieštia, vyhľadávanie zaberie čas a ústne dohody sa strácajú. Aplikácia na správu koní zhromažďuje všetko pri každom koni s automatickými pripomienkami.",
      },
      {
        q: "Koľko stojí EquiSight?",
        a: "Môžete začať zadarmo s 1 koňom. Ak chcete spravovať viacero koní, aktivovať chov alebo udeliť prístup profesionálom, existujú dostupné prémiové plány. Aktuálne možnosti nájdete na stránke s cenami.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Softvér pre chov koní: kompletné porovnanie 2026",
      description: "Porovnajte softvér pre chov koní: cyklus kobýl, gravidita, výber žrebca a žriebätá. Zistite, prečo je EquiSight kompletná aplikácia pre chov koní.",
      keywords: [
        "softvér pre chov koní",
        "aplikácia cyklus kobyly",
        "aplikácia gravidita kobyly",
        "aplikácia registrácia žriebäťa",
        "aplikácia plemenná kniha koní",
        "plánovanie krytia koní",
        "aplikácia výber žrebca",
      ],
    },
    hero: {
      eyebrow: "Pomoc pri výbere · softvér pre chov koní",
      breadcrumbLabel: "Softvér pre chov koní",
      title: "Softvér pre chov koní: kompletné porovnanie na rok 2026.",
      intro: "Plemenná kobyla si zaslúži viac než bežnú aplikáciu na správu koní. Porovnajte funkcie chovu najznámejších nástrojov, zistite, na čo sa skutočne musíte sústrediť, a vedome si vyberte softvér, ktorý vyhovuje vašej žrebčnici — veľkej či malej.",
      pills: [
        {
          icon: "Baby",
          label: "Cyklus kobyly",
        },
        {
          icon: "Heart",
          label: "Kontrola gravidity",
        },
        {
          icon: "Sparkles",
          label: "Vývoj žriebäťa",
        },
        {
          icon: "FileText",
          label: "Plemenná kniha",
        },
      ],
      ctas: [
        {
          label: "Začnite zadarmo s modulom chovu",
          href: "#start",
          primary: true,
        },
        {
          label: "Na porovnávaciu tabuľku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Prečo bežná aplikácia na správu koní nestačí pre chov.",
      lead: "Väčšina aplikácií pre jazdecký šport je navrhnutá pre jedného športového alebo rekreačného koňa. Chov má úplne iný rytmus: rijalosť, inseminácia, kontrola gravidity, ultrazvuky, kalendár žriebät, rodokmeň a predaj. Jeden Excel sa po 2 sezónach rozpadne — a pri viacerých kobylách strácate prehľad.",
      items: [
        "Kedy bol naposledy cyklus Bonity?",
        "Ktorý žrebec je naplánovaný na krytie v budúcej sezóne?",
        "Je už naplánovaný 21-dňový ultrazvuk?",
        "Ktoré žriebätá z roku 2024 sú už predané?",
        "Kde je diagram rodokmeňa až po starého otca z matkinej strany?",
        "Kde sú vzorky DNA a údaje z pasu?",
      ],
    },
    what: {
      title: "Čo je softvér pre chov koní?",
      lead: "Softvér pre chov koní je špecializovaná karta pre každú kobylu a žrebca, kombinovaná s kalendárom chovného roku, plánovaním gravidity, registráciou žriebät a zobrazením rodokmeňa. Nie je to všeobecný denník koní, ale nástroj, ktorý rozumie chovnému cyklu: od prvej rijalosti až po odstavenie.",
      targetGroupsTitle: "Pre aký typ chovateľa je softvér pre chov koní určený?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobby chovateľ (1-3 kobyly)",
          body: "Jedno alebo dve krytia ročne — prehľad bez akrobatiky v Exceli.",
        },
        {
          icon: "Building2",
          title: "Malá žrebčnica (4-10 kobýl)",
          body: "Plán chovného roku s cyklom, insemináciou, kontrolami gravidity a kartou žriebäťa.",
        },
        {
          icon: "Users",
          title: "Profesionálna žrebčnica (10+)",
          body: "Viacero zamestnancov, výber žrebca pre každú kobylu, predaj a marketing.",
        },
        {
          icon: "Target",
          title: "Majiteľ žrebca",
          body: "História objednávok, štatistiky semena a kalendár pre každého žrebca.",
        },
        {
          icon: "Heart",
          title: "Embryotransfer",
          body: "Darca + prijímateľka ako prepojená karta, kalendár ET.",
        },
        {
          icon: "ClipboardList",
          title: "Registrácia plemennej knihy",
          body: "Vzorky DNA, doklady z pasu a údaje rodokmeňa.",
        },
      ],
    },
    criteria: {
      title: "Čo musí dobrý softvér pre chov koní spĺňať?",
      lead: "Nie každá 'funkcia chovu' v aplikácii pre kone je rovnaká. Päť kľúčových oblastí, kde chovatelia strácajú veľa času — a kde softvér skutočne robí rozdiel.",
      items: [
        {
          icon: "Calendar",
          title: "Cyklus kobyly a rijalosť",
          body: "Denný záznam, prediktívna ovulácia, posun cyklu a automatické pripomienky.",
        },
        {
          icon: "Heart",
          title: "Inseminácia a kontrola gravidity",
          body: "Dátumy krytia a inseminácie, údaje o žrebcovi, 14-dňový ultrazvuk, 21-dňový ultrazvuk, 60-dňový ultrazvuk a určenie pohlavia.",
        },
        {
          icon: "Baby",
          title: "Vývoj žriebäťa",
          body: "Údaje o narodení, graf hmotnosti, odčervovací harmonogram, moment odstavenia, registrácia pasu.",
        },
        {
          icon: "FileText",
          title: "Rodokmeň a doklady",
          body: "Zobrazenie rodokmeňa až do 4-5 generácií, DNA, čísla pasov a stav v plemennej knihe.",
        },
        {
          icon: "Target",
          title: "Výber žrebca a párenie",
          body: "Filtrovanie podľa disciplíny, línií, údajov o žrebcovi a historického úspechu — nielen to, čo presadzuje majiteľ žrebca.",
        },
        {
          icon: "Share2",
          title: "Spolupráca s veterinárom/inseminátorom",
          body: "Ultrazvuky, vzorky a statusy zdieľané priamo s praxou, ktorá pracuje s vašimi kobylami.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs iný softvér pre chov koní.",
      lead: "Slovenské výsledky vyhľadávania pre softvér chovu koní často zobrazujú všeobecné aplikácie pre kone, ktoré chov spomínajú jednou vetou. Poctivo porovnávame, ktoré nástroje skutočne majú kompletnú funkciu chovu.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Začať zadarmo",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Zaznamenávanie cyklu kobyly",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dátum inseminácie + žrebec",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrazvuky a kontrola gravidity",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Očakávaný dátum žriebäťa",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Karta žriebäťa (hmotnosť/rast)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rodokmeň do 4-5 generácií",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA a registrácia pasu",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Výber žrebca / párenie",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryotransfer",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Prehľad viacerých kobýl",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilná aplikácia (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Zdieľanie s veterinárom",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrované so všeobecnou kartou",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Predaj a marketing žriebät",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Porovnanie na základe verejne dostupných funkcií v januári 2026. EquineGenie je silný v chove, ale slabší v mobilnom riešení a všeobecnej správe koní. EquiSight kombinuje oboje.",
    },
    why: {
      title: "Prečo EquiSight slúži chovateľom inak.",
      lead: "Mnoho chovateľov pracuje s oddeleným softvérom pre chov a s inou aplikáciou na správu koní. EquiSight kombinuje oboje — bez prepínania medzi aplikáciami alebo dvojitého zadávania údajov.",
      points: [
        {
          icon: "Heart",
          title: "Plemenná kobyla zostáva aj bežným koňom",
          body: "Plemenná kobyla má chovný rok aj bežnú kartu koňa — zdravie, očkovanie, kováč. Jedna aplikácia, všetky moduly.",
        },
        {
          icon: "Sparkles",
          title: "Prediktívne namiesto reaktívneho",
          body: "Predpoveď cyklu, pripomienky míľnikov gravidity a kalendár žriebät — automaticky na základe vašich údajov.",
        },
        {
          icon: "Share2",
          title: "Každý okolo chovu",
          body: "Inseminátor, majiteľ žrebca, veterinár, kupujúci, plemenná kniha — všetci majú prístup so správnymi právomocami.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Podľa disciplíny · od cyklu po odstavenie",
      title: "Čo obsahuje chovná karta v EquiSight.",
      lead: "Pre každú kobylu získate kompletnú chovnú kartu, prepojenú s jej bežnou kartou koňa.",
      items: [
        "Denný záznam cyklu s predpoveďou",
        "Inseminácia/krytie + údaje o žrebcovi",
        "Časová os ultrazvukov (14/21/60 dní + pohlavie)",
        "Míľniky gravidity s automatickými pripomienkami",
        "Očakávaný dátum žriebäťa a príprava",
        "Karta žriebäťa od narodenia",
        "Rodokmeň až po starých rodičov s navigáciou kliknutím",
        "Vzorka DNA, pas, stav plemennej knihy",
        "Predajný pipeline so záujemcami",
        "História výberu žrebca pre každú kobylu",
      ],
      ctaLabel: "Pozrite si modul chovu",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Pre celú žrebčnicu",
      title: "Prehľad pre viacero kobýl a žrebcov.",
      lead: "Keď chováte viac ako 2-3 kobyly, prehľad o všetkých cykloch a graviditách sa stáva kľúčovým.",
      cards: [
        {
          t: "Dashboard cyklov",
          d: "Všetky kobyly vedľa seba s fázou cyklu a ďalšou akciou.",
        },
        {
          t: "Pipeline gravidity",
          d: "Ktoré kobyly sú v akom míľniku gravidity?",
        },
        {
          t: "Kalendár žriebät",
          d: "Očakávané pôrody po mesiacoch s prispôsobenou logistikou.",
        },
        {
          t: "Portfólio žrebcov",
          d: "Vlastní žrebci alebo stáli inseminátori s históriou objednávok.",
        },
        {
          t: "Graf rodokmeňa",
          d: "Analýza predkov cez viacero generácií a línií.",
        },
        {
          t: "Dashboard predaja",
          d: "Ktoré žriebätá sú predané, rezervované alebo stále dostupné.",
        },
      ],
    },
    beforeAfter: {
      title: "Od Excelu a diára k EquiSight chovu.",
      lead: "Konkrétne: takto sa zmení vaša chovná sezóna.",
      rows: [
        {
          before: "Cyklus v oddelených poznámkach",
          after: "Denný záznam s predpoveďou",
        },
        {
          before: "Ultrazvuky cez WhatsApp inseminátorovi",
          after: "Zdieľaná karta s fotografiami",
        },
        {
          before: "Dátum gravidity v diári",
          after: "Automatické pripomienky míľnikov",
        },
        {
          before: "Pas žriebäťa v zásuvke",
          after: "Dokument prepojený s profilom žriebäťa",
        },
        {
          before: "Rodokmeň na papieri",
          after: "Klikateľný rodokmeň do 4-5 generácií",
        },
        {
          before: "Inzerát na predaj na Marktplaats",
          after: "Predajný pipeline so zoznamom záujemcov",
        },
      ],
    },
    helper: {
      title: "Ktorý softvér pre chov koní je pre vás vhodný?",
      lead: "5 otázok, aby ste zistili, či potrebujete kompletnú aplikáciu pre chov alebo vám postačí hobby nástroj.",
      questions: [
        {
          id: "mares",
          q: "Koľko plemenných kobýl spravujete?",
          options: [
            {
              label: "1 kobyla",
              score: 1,
            },
            {
              label: "2-5 kobýl",
              score: 2,
            },
            {
              label: "Viac ako 5 kobýl",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Ako často chováte za rok?",
          options: [
            {
              label: "Príležitostne (každé pár rokov)",
              score: 0,
            },
            {
              label: "Každý rok 1-2 krytia",
              score: 2,
            },
            {
              label: "Každý rok 3+ krytí",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Ako inseminujete/kryje?",
          options: [
            {
              label: "Prirodzené krytie",
              score: 1,
            },
            {
              label: "UI čerstvé/chladené semeno",
              score: 2,
            },
            {
              label: "ET alebo mrazené semeno",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Spolupracujete s veterinárom/inseminátorom?",
          options: [
            {
              label: "Jedna stála osoba",
              score: 1,
            },
            {
              label: "Viaceré praxe",
              score: 2,
            },
            {
              label: "Medzinárodná sieť",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Čo teraz sledujete?",
          options: [
            {
              label: "Excel alebo papier",
              score: 1,
            },
            {
              label: "Všeobecná aplikácia na správu koní",
              score: 2,
            },
            {
              label: "Nič štruktúrované",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Postačí hobby nástroj alebo Excel — ale EquiSight je stále užitočný.",
          body: "Pre 1 kobylu s prirodzeným krytím každé pár rokov je rozsiahly modul chovu nadbytočný. EquiSight začína zadarmo a modul chovu aktivujete iba pre rok, v ktorom kryje — bez povinného upgradu.",
          cta: "Začať zadarmo",
        },
        mid: {
          title: "EquiSight chov je ten správny nástroj.",
          body: "Máte viacero kobýl alebo viacero metód chovu — na to všeobecné aplikácie pre kone nie sú stavané. EquiSight kombinuje chov a všeobecnú starostlivosť, takže neprepínate medzi dvoma nástrojmi.",
          cta: "Pozrite si modul chovu",
        },
        high: {
          title: "EquiSight je stavaný pre vašu žrebčnicu.",
          body: "Viacero kobýl, ET alebo mrazené semeno, medzinárodný tím — väčšina nástrojov tu zlyhá. EquiSight rastie až na úroveň žrebčnice bez toho, aby ste hromadili ďalšie licencie.",
          cta: "Porozprávajte sa s nami o pláne pre žrebčnicu",
        },
      },
    },
    faqTitle: "Často kladené otázky o softvéri pre chov koní",
    faq: [
      {
        q: "Aký je najlepší softvér pre chov koní?",
        a: "Pre 1 kobylu bez zložitej metódy chovu postačí veľa nástrojov. Od 2-3 kobýl, pri použití UI alebo ET, alebo pri spolupráci s veterinárom a plemennou knihou sa kompletný modul chovu stáva kľúčovým. EquiSight kombinuje chov so všeobecnou správou koní v jednej aplikácii, takže nemusíte prepínať.",
      },
      {
        q: "Ktoré funkcie chovu skutočne potrebujem?",
        a: "Minimálne: záznam cyklu, údaje o inseminácii/krytí, míľniky kontroly gravidity a karta žriebäťa. Voliteľné, ale výkonné: zobrazenie rodokmeňa, archív výberu žrebca, DNA/pas a predajný pipeline.",
      },
      {
        q: "Dokáže EquiSight predpovedať cyklus kobyly?",
        a: "Áno. EquiSight používa predchádzajúce údaje cyklu na zobrazenie predpokladanej ovulácie, aby ste insemináciu alebo krytie naplánovali v správnom čase — bez každodenného hádania.",
      },
      {
        q: "Funguje EquiSight aj pre embryotransfer?",
        a: "Áno. Darca a prijímateľka dostanú prepojené karty, kalendár ET a zdieľané míľniky s praxou. Tak nestratíte časovú os v zložitom procese ET.",
      },
      {
        q: "Môžem importovať existujúce chovné údaje?",
        a: "Cyklus, krytia a údaje o žriebätách môžete zadať ručne alebo hromadne cez CSV. Pri aktívnych chovoch pomáhame s jednorazovou migráciou, ak máte údaje za viacero sezón.",
      },
      {
        q: "Ako zdieľam kartu s mojím veterinárom alebo inseminátorom?",
        a: "Každá osoba dostane prístup s rolou: veterinár, inseminátor, majiteľ žrebca alebo funkcionár plemennej knihy. Každý vidí iba informácie potrebné pre jeho rolu — úplný prístup nie je potrebný.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software pre jazdecký areál: kompletné porovnanie & sprievodca výberom 2026",
      description: "Porovnajte softvér pre jazdecké areály pre lekcie, jazdcov, kone a administratívu. Zistite, ktorá aplikácia je vhodná pre váš jazdecký areál alebo penzionát.",
      keywords: [
        "softvér pre jazdecký areál",
        "aplikácia na správu stajne",
        "administratívny softvér pre jazdecký areál",
        "plánovanie hodín jazdecký areál",
        "softvér pre penzionát koní",
        "administrácia jazdcov",
        "administrácia koní jazdecký areál",
      ],
    },
    hero: {
      eyebrow: "Sprievodca výberom · softvér pre jazdecký areál",
      breadcrumbLabel: "Softvér pre jazdecký areál",
      title: "Softvér pre jazdecký areál: kompletný sprievodca výberom pre jazdecké areály a penzionáty.",
      intro: "Plánovanie hodín, administrácia jazdcov, správa koní, fakturácia a komunikácia — kvalitný softvér pre jazdecký areál to všetko spojí. Porovnajte najznámejšie možnosti a zistite, ktorá sa hodí pre vašu stajňu alebo jazdecký areál.",
      pills: [
        {
          icon: "Calendar",
          label: "Plánovanie hodín",
        },
        {
          icon: "Users",
          label: "Jazdci & klienti",
        },
        {
          icon: "Heart",
          label: "Starostlivosť o kone",
        },
        {
          icon: "CreditCard",
          label: "Fakturácia",
        },
      ],
      ctas: [
        {
          label: "Požiadajte o demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Na porovnávaciu tabuľku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Prečo roztrieštenené nástroje spomaľujú jazdecký areál.",
      lead: "Väčšina jazdeckých areálov funguje na záplate: plánovanie hodín na bielej tabuli, evidencia jazdcov v Excel, fakturácia v inom nástroji, starostlivosť o kone cez WhatsApp a kontakt s majiteľmi cez osobné správy. Pri rušnom týždni vznikajú dvojité rezervácie, zabudnuté faktúry alebo kone, ktoré nevedia, ktorého jazdca dostanú.",
      items: [
        "Kto je teraz na hodine u Jasmíny?",
        "Ktorý jazdec ešte nezaplatil za marec?",
        "Ktorý kôň sa tento týždeň nesmie používať?",
        "Kto sú núdzové kontakty žiakov?",
        "Dostal majiteľ Stardusta už faktúru od kováča?",
        "Ktorý kôň stojí v ktorom boxe?",
      ],
    },
    what: {
      title: "Čo je softvér pre jazdecký areál?",
      lead: "Softvér pre jazdecký areál kombinuje plánovanie hodín, administráciu jazdcov, správu koní, fakturáciu a komunikáciu v jednom nástroji. Žiadna akrobacia s Excel ani spaghetti WhatsApp, ale jedno miesto, kde areál funguje a majitelia/jazdci majú prehľad.",
      targetGroupsTitle: "Pre aký typ podniku je softvér pre jazdecký areál určený?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Malý jazdecký areál (1–15 koní)",
          body: "Hlavne plánovanie hodín a platby — administratíva bez bolesti hlavy.",
        },
        {
          icon: "Users",
          title: "Stredne veľký jazdecký areál (15–40 koní)",
          body: "Viacero inštruktorov, plánovanie hodín + rozvrh koní + administrácia jazdcov.",
        },
        {
          icon: "ClipboardList",
          title: "Veľká jazdiareň a penzionát (40+)",
          body: "Kompletná prevádzka vrátane fakturácie, plánovania kŕmenia a kováča.",
        },
        {
          icon: "Heart",
          title: "Penzionát koní",
          body: "Portál pre majiteľov, individuálne pokyny starostlivosti, zdieľaný kalendár.",
        },
        {
          icon: "Target",
          title: "Tréningová stajňa skokárov",
          body: "Plánovanie súťaží, tréning pre každého koňa, kontakt s klientmi.",
        },
        {
          icon: "FileText",
          title: "Hipický podnikateľ",
          body: "Mix hodín + penzionátu + clinicu + obchodu — všetko z jedného systému.",
        },
      ],
    },
    criteria: {
      title: "Čomu musí dobrý softvér pre jazdecký areál vyhovieť?",
      lead: "Pekná aplikácia nič neznamená, ak s ňou zamestnanci nechcú pracovať. Päť praktických kritérií, ktoré rozhodujú medzi úspechom a frustráciou.",
      items: [
        {
          icon: "Calendar",
          title: "Plánovanie hodín na viacerých úrovniach",
          body: "Začiatočník/pokročilý, drezúra/skoky, väzby koňa a kalendáre inštruktorov — všetko viditeľné vedľa seba.",
        },
        {
          icon: "Users",
          title: "Administrácia jazdcov",
          body: "Profily, úroveň, predplatné, permanentka a rodinné väzby pre mládežníckych jazdcov.",
        },
        {
          icon: "Heart",
          title: "Rozvrh koní",
          body: "Ako často je ktorý kôň nasadený, s obdobiami odpočinku, zranenia a ruje.",
        },
        {
          icon: "CreditCard",
          title: "Fakturácia & predplatné",
          body: "Mesačné predplatné, permanentky, jednotlivé hodiny a automatický inkaso.",
        },
        {
          icon: "Share2",
          title: "Portál pre majiteľov (penzionát)",
          body: "Majitelia vidia svojho koňa vo vlastnej aplikácii — kalendár, náklady, kováč a poznámky bez telefonovania.",
        },
        {
          icon: "Bell",
          title: "Komunikácia & pripomienky",
          body: "Automatické pripomienky hodín, upozornenia na platby, oznámenia kováča — bez posielania správ.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs iný softvér pre jazdecké areály.",
      lead: "Mnohé nástroje pre jazdecké areály sú silné v plánovaní hodín alebo fakturácii, ale zriedkakedy zároveň v starostlivosti o kone a komunikácii s majiteľmi. Porovnávame ich férovo vedľa seba.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Bezplatný štart / skúšobné obdobie",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Plánovanie hodín",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Viacero inštruktorov",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administrácia jazdcov",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Rozvrh koní",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Starostlivosť o kone (vacc/kováč)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Permanentka / predplatné",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online platby",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatická fakturácia",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portál pre majiteľov (penzionát)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrácia kováč/veterinár",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS pripomienky",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilná aplikácia (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Plánovanie súťaží",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vhodné pre penzionát koní",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Porovnanie na základe verejne dostupných funkcií v januári 2026. Stalmanager je silný v administratíve, EquiSight sa odlišuje plynulosťou penzionátu + starostlivosťou o kone + portálom pre majiteľov.",
    },
    why: {
      title: "Prečo je EquiSight iný pre jazdecké areály a penzionáty.",
      lead: "EquiSight ide ďalej ako plánovač hodín. Jazdecký areál vnímame ako kompletnú prevádzku: kone, ľudia, komunikácia a financie — všetko navzájom prepojené.",
      points: [
        {
          icon: "Heart",
          title: "Kôň v centre, nie kalendár",
          body: "Každý kôň má vlastný spis. Nasadenie v hodinách, zdravie, kováč a súťaže v jednej časovej osi — nie 3 samostatné nástroje.",
        },
        {
          icon: "Share2",
          title: "Majitelia majú prehľad bez telefonovania",
          body: "Majitelia penzionátu majú vlastný pohľad: náklady, plán, fotografie a poznámky — šetrí 5–10 telefonátov týždenne.",
        },
        {
          icon: "Bell",
          title: "Automatická komunikácia",
          body: "Pripomienka hodiny, pripomienka vakcinácii, faktúra — automaticky, cez aplikáciu/email/SMS. Žiadne hromadné WhatsApp správy.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pre penzionát koní",
      title: "Čo penzionát získa od EquiSight.",
      lead: "Penzionáty majú jedinečné výzvy, ktoré bežný softvér pre jazdecké areály nerieši.",
      cards: [
        {
          t: "Portál pre majiteľov",
          d: "Každý majiteľ vidí iba svojho koňa (koňov), kalendár a náklady.",
        },
        {
          t: "Pokyny starostlivosti pre každého koňa",
          d: "Krmivo, hrubé krmivo, doplnky, rozvrh diek — viditeľné pre stajňu.",
        },
        {
          t: "Zdieľaný kalendár",
          d: "Kováč, veterinár a návštevy majiteľov v jednom pohľade.",
        },
        {
          t: "Prevádzkové náklady na koňa",
          d: "Podstielka, krmivo, jadrové krmivo účtované každému majiteľovi.",
        },
        {
          t: "Núdzové kontakty koňa",
          d: "Majiteľ + veterinár + kováč vždy dostupní pre stajňu.",
        },
        {
          t: "Správa pastvy",
          d: "Ktoré kone idú na pasienok, na odpočinok alebo do rehabilitácie?",
        },
      ],
    },
    beforeAfter: {
      title: "Od bielej tabule + Excel k EquiSight.",
      lead: "Konkrétne: takto sa zmení pracovný týždeň v jazdeckom areáli.",
      rows: [
        {
          before: "Biela tabuľa s plánovaním hodín",
          after: "Živý plán pre každého inštruktora",
        },
        {
          before: "Excel s jazdcami + poznámkami z hodín",
          after: "CRM klientov s históriou hodín",
        },
        {
          before: "WhatsApp majiteľom",
          after: "Portál pre majiteľov pre ich koňa",
        },
        {
          before: "Mesačný inkaso manuálne",
          after: "Automatická fakturácia + iDEAL",
        },
        {
          before: "Starostlivosť o kone na papierovej nástenke",
          after: "Pokyny starostlivosti pre každého koňa, zdieľané",
        },
        {
          before: "Ústna dohoda s kováčom",
          after: "Plánovanie kováča s potvrdeniami",
        },
      ],
    },
    helper: {
      title: "Ktorý softvér pre jazdecký areál vám vyhovuje?",
      lead: "5 otázok, aby ste zistili, či je EquiSight tou správnou platformou pre váš jazdecký areál alebo penzionát.",
      questions: [
        {
          id: "size",
          q: "Koľko koní máte vo svojom podniku?",
          options: [
            {
              label: "Menej ako 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Viac ako 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Aká je vaša hlavná činnosť?",
          options: [
            {
              label: "Hlavne výučba jazdenia",
              score: 1,
            },
            {
              label: "Penzionát koní",
              score: 3,
            },
            {
              label: "Mix výučby + penzionátu",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "S koľkými inštruktormi pracujete?",
          options: [
            {
              label: "Iba ja sám/sama",
              score: 1,
            },
            {
              label: "2–3 inštruktori",
              score: 2,
            },
            {
              label: "4 alebo viac",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Ako momentálne riešite fakturáciu?",
          options: [
            {
              label: "Manuálne (Word/Excel)",
              score: 3,
            },
            {
              label: "Samostatný účtovný program",
              score: 2,
            },
            {
              label: "Integrované v nástroji na hodiny",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Ako komunikujete s majiteľmi?",
          options: [
            {
              label: "Osobne / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Portál pre majiteľov v nástroji",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednoduchý nástroj alebo Excel zatiaľ postačí — ale EquiSight rastie s vami.",
          body: "Pre malý podnik s jedným inštruktorom a malým počtom penzionátov nie je rozsiahly balík hneď potrebný. EquiSight začína zadarmo a rastie spolu s vaším jazdeckým areálom — žiadna bolestivá migrácia o pár rokov.",
          cta: "Začnite zadarmo",
        },
        mid: {
          title: "EquiSight je logický upgrade pre váš jazdecký areál.",
          body: "Viacero inštruktorov, mix výučby a penzionátu alebo fakturácia, ktorá stojí bokom — EquiSight to všetko spojí do jedného pracovného procesu. Portál pre majiteľov ušetrí veľa ad-hoc komunikácie.",
          cta: "Požiadajte o demo",
        },
        high: {
          title: "EquiSight je stavaný pre vašu veľkosť.",
          body: "Penzionát + hodiny + viacero inštruktorov — presne tam sa EquiSight odlišuje od klasických nástrojov pre jazdecké areály. Portál pre majiteľov a integrácia starostlivosti o kone šetria každý týždeň hodiny administratívy a komunikácie.",
          cta: "Naplánujte demo pre vašu stajňu",
        },
      },
    },
    faqTitle: "Často kladené otázky o softvéri pre jazdecké areály",
    faq: [
      {
        q: "Aký je najlepší softvér pre jazdecký areál?",
        a: "Pre čisté plánovanie hodín existuje viacero dobrých možností. Akonáhle potrebujete penzionát, viacerých inštruktorov alebo sledovanie starostlivosti o kone, EquiSight sa stáva komplexným riešením — žiadne žonglovanie s nástrojmi, všetko na jednom mieste.",
      },
      {
        q: "Môžem importovať existujúcich klientov a hodiny?",
        a: "Áno. Údaje o klientoch a rozvrhy hodín môžete importovať cez CSV. Aktívnym jazdeckým areálom pomáhame s jednorazovou migráciou, aby ste nemuseli zadávať 200 jazdcov manuálne.",
      },
      {
        q: "Funguje to aj pre penzionát bez hodín?",
        a: "Áno. Režim penzionátu vypne hodiny a zameria sa na portál pre majiteľov, kŕmenie/starostlivosť, plánovanie kováča a účtovanie nákladov za každého koňa.",
      },
      {
        q: "Môžu sa jazdci sami prihlasovať a platiť?",
        a: "Áno. Jazdci môžu cez vlastný účet vidieť, ktoré hodiny sú voľné, prihlásiť sa, zaplatiť lekcie pomocou iDEAL a kúpiť permanentky.",
      },
      {
        q: "Ako je to s ochranou súkromia údajov koní a majiteľov?",
        a: "Každá osoba má rolu (majiteľ, jazdec, inštruktor, zamestnanec). Každá rola vidí iba to, čo potrebuje. Majitelia vidia iba svojho koňa, jazdci iba vlastné hodiny.",
      },
      {
        q: "Môže EquiSight prepojiť s mojim účtovným softvérom?",
        a: "Áno, dostupné sú prepojenia s Exact, Moneybird a e-Boekhouden. Faktúry sa potom automaticky prenášajú do vášho účtovníctva.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trénerská aplikácia pre kone: porovnanie a pomoc pri výbere pre koučov 2026",
      description: "Porovnajte trénerské aplikácie pre koňa a jazdca: tréningový denník, video, ciele, analýza protokolov a správa klientov. Nájdite správny nástroj pre koučov.",
      keywords: [
        "trénerská aplikácia pre kone",
        "aplikácia pre inštruktora",
        "aplikácia na tréning koní",
        "aplikácia na koučovanie jazdcov",
        "tréningový denník koňa",
        "analýza dresúrneho protokolu",
        "softvér pre trénera koní",
      ],
    },
    hero: {
      eyebrow: "Pomoc pri výbere · softvér pre trénera",
      breadcrumbLabel: "Trénerská aplikácia",
      title: "Trénerská aplikácia pre kone: kompletný sprievodca výberom pre inštruktorov a koučov.",
      intro: "Tréner alebo inštruktor žongluje s kombináciami, lekciami, videami, cieľmi a súťažami. Porovnajte najlepšie trénerské aplikácie pre ľudí z koňského sveta a vyberte platformu, ktorá bude rásť spolu s vašim koučovaním aj v roku 2026.",
      pills: [
        {
          icon: "Target",
          label: "Ciele a plánovanie",
        },
        {
          icon: "Video",
          label: "Video analýza",
        },
        {
          icon: "TrendingUp",
          label: "Pokrok",
        },
        {
          icon: "Users",
          label: "Klienti/kombinácie",
        },
      ],
      ctas: [
        {
          label: "Začnite zadarmo ako tréner",
          href: "#start",
          primary: true,
        },
        {
          label: "Na porovnávaciu tabuľku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Prečo koučovanie cez WhatsApp trénerom prekáža.",
      lead: "Väčšina trénerov pracuje s rôznymi nástrojmi: WhatsApp na komunikáciu, poznámkový blok na lekcie, YouTube alebo WeTransfer na videá a Excel na súťažné výsledky. Pri 5 jazdcoch to funguje. Pri 20 jazdcoch sa informácie strácajú, zabúdate na ciele a strácate prehľad o individuálnom pokroku.",
      items: [
        "Kde je cieľ Anouk na túto sezónu?",
        "Aké video som minulý mesiac poslal Bramovi?",
        "Videla Lara analýzu protokolu z jej poslednej súťaže?",
        "Ktorá kombinácia trénuje koľkokrát týždenne?",
        "Prečítal si majiteľ Stardust moje tréningové pokyny?",
        "Kedy som naposledy dal spätnú väzbu na kolísavý impulz?",
      ],
    },
    what: {
      title: "Čo je trénerská aplikácia pre koňa a jazdca?",
      lead: "Trénerská aplikácia kombinuje koučovací CRM (kombinácie, lekcie, ciele), tréningový denník pre každého koňa, video spätnú väzbu, plánovanie súťaží a analýzu protokolov. Žiadny samostatný WhatsApp/YouTube/Excel — len jedna platforma, kde tréner a jazdec spolupracujú.",
      targetGroupsTitle: "Pre aký typ trénera je to určené?",
      targetGroups: [
        {
          icon: "Target",
          title: "Inštruktor dresúry",
          body: "Skenovanie protokolov, prepojenie komentárov rozhodcov s tréningovými cieľmi, sledovanie pokroku.",
        },
        {
          icon: "Activity",
          title: "Tréner skákania",
          body: "Plánovanie parkúra, spätná väzba po kolách, správa výšok pre každého koňa.",
        },
        {
          icon: "Award",
          title: "Eventing kouč",
          body: "Tri disciplíny, tri plány — všetko viditeľné vedľa seba.",
        },
        {
          icon: "TrendingUp",
          title: "Výkonnostný kouč (šport)",
          body: "Sledovanie EPI, súťaže, ciele — pre vrcholových športovcov a ich tímy.",
        },
        {
          icon: "Users",
          title: "Inštruktor jazdiarní",
          body: "Skupinové lekcie aj individuálne koučovanie v jednej aplikácii.",
        },
        {
          icon: "Heart",
          title: "Rekreačný kouč",
          body: "Hipoterpia, začiatočníci, majitelia s jedným koňom.",
        },
      ],
    },
    criteria: {
      title: "Čo musí dobrá trénerská aplikácia spĺňať?",
      lead: "Trénovanie je ľudská práca, ale správny nástroj vás urobí o 30–50 % efektívnejšími a pomáha jazdcom zlepšovať sa aj medzi lekciami.",
      items: [
        {
          icon: "Users",
          title: "Správa kombinácií",
          body: "Kôň a jazdec ako jedna jednotka, s úrovňou, cieľmi, pokrokom a históriou.",
        },
        {
          icon: "ClipboardList",
          title: "Poznámky z lekcií a ciele",
          body: "K každej lekcii poznámka s kľúčovými bodmi, prepojená s dlhodobými cieľmi.",
        },
        {
          icon: "Video",
          title: "Video spätná väzba",
          body: "Nahrajte video, označte momenty, pridajte hovorenú alebo písanú spätnú väzbu.",
        },
        {
          icon: "Target",
          title: "Analýza súťaží a protokolov",
          body: "Skenujte protokoly (KNHS/FEI), sledujte skóre podľa prvkov, komentáre rozhodcov a trendy.",
        },
        {
          icon: "Calendar",
          title: "Plánovanie a lekciové karty",
          body: "Kalendár, platby, predplatné a automatické pripomienky.",
        },
        {
          icon: "Share2",
          title: "Komunikácia s jazdcom",
          body: "Jazdec vidí svoju vlastnú stránku s lekciami, videami, cieľmi a spätnou väzbou.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs iné trénerské aplikácie.",
      lead: "Niektoré trénerské nástroje sa zameriavajú na nahradenie WhatsAppu, iné na analýzu protokolov. EquiSight kombinuje oboje so skutočným koňským dosiarom — aby sa jazdec zlepšoval aj medzi lekciami.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Začať zadarmo",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Správa kombinácií",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Poznámky z lekcií a spätná väzba",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dlhodobé ciele",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Nahrávanie videa a spätná väzba",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Skenovanie protokolov KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (index výkonnosti)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalendár súťaží",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portál jazdca",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Lekciová karta / predplatné",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online platby",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrovaný koňský dosiar",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Viditeľný kováč/veterinár",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pre inštruktora AJ jazdca",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Viac koní na jazdca",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Porovnanie na základe verejne dostupných funkcií v januári 2026. EquiSight je jedinečný v analýze protokolov + EPI a zároveň to kombinuje s všeobecnou správou koní.",
    },
    why: {
      title: "Prečo EquiSight ponúka iný trénerský zážitok.",
      lead: "Väčšina trénerských nástrojov končí tam, kde sa skončí lekcia. EquiSight pokračuje ďalej — v koňskom dossiere, v analýze súťaží, v spolupráci s veterinárom a majiteľom.",
      points: [
        {
          icon: "TrendingUp",
          title: "Skenovanie protokolu → tréningový cieľ",
          body: "Naskenujte protokol KNHS a okamžite uvidíte, ktoré prvky si vyžadujú pozornosť. Ciele sa automaticky vynárajú.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach posilňuje váš pohľad",
          body: "Údaje z viacerých lekcií, súťaží a protokolov odhaľujú vzory, ktoré si v hlave neudržíte.",
        },
        {
          icon: "Share2",
          title: "Integrované s koňom",
          body: "Tréner vidí históriu očkovania, kováča a zranení koňa — žiadne plánovanie tréningu počas zotavenia.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Pre dresúru a skákanie",
      title: "Čo obsahuje koučovací dosiar v EquiSight.",
      lead: "Každá kombinácia dostane koučovací stream, ktorý drží všetko pohromade — žiadne viac stratené veci vo WhatsAppe.",
      items: [
        "Poznámky z lekcií s kľúčovými bodmi každého sedenia",
        "Dlhodobé ciele a míľniky",
        "Nahrávanie videa s komentármi na časovej osi",
        "Skenovanie protokolov KNHS/FEI so skóre",
        "Komentáre rozhodcov prepojené s tréningom",
        "Súťažné výsledky a trend EPI",
        "Kontakt s klientom a história lekcií",
        "Lekciová karta / predplatné / faktúry",
        "Graf pokroku podľa disciplíny",
        "Zdieľaný prístup s majiteľom koňa",
      ],
      ctaLabel: "Pozrite si modul pre trénera",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Od WhatsAppu a YouTube k EquiSight Trainer.",
      lead: "Konkrétne: takto sa zmení váš koučovací workflow.",
      rows: [
        {
          before: "WhatsApp s oddelenými video odkazmi",
          after: "Video s časovou spätnou väzbou v dossiere",
        },
        {
          before: "Poznámkový blok na jazdca",
          after: "Koučovací denník s cieľmi a históriou",
        },
        {
          before: "Excel so súťažnými skóre",
          after: "EPI graf a analýza protokolov",
        },
        {
          before: "Ústne dohodnuté ciele",
          after: "Míľniky s indikátorom pokroku",
        },
        {
          before: "Samostatný nástroj na fakturáciu",
          after: "Lekcie + iDEAL + predplatné v aplikácii",
        },
        {
          before: "E-mail majiteľovi o pokroku",
          after: "Majiteľ sleduje vo vlastnom zobrazení",
        },
      ],
    },
    helper: {
      title: "Ktorá trénerská aplikácia je pre vás vhodná?",
      lead: "5 otázok, aby ste zistili, či by špecializovaný koučovací nástroj mal pre vašu prax pridanú hodnotu.",
      questions: [
        {
          id: "clients",
          q: "Koľko aktívnych kombinácií koučujete?",
          options: [
            {
              label: "Menej ako 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Viac ako 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Aká je vaša hlavná disciplína?",
          options: [
            {
              label: "Dresúra",
              score: 3,
            },
            {
              label: "Skákanie",
              score: 2,
            },
            {
              label: "Rekreačné / rôzne",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Používate pri koučovaní video?",
          options: [
            {
              label: "Zriedkavo",
              score: 0,
            },
            {
              label: "Niekedy (ručne)",
              score: 2,
            },
            {
              label: "Často — systematicky",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Koučujete súťažných jazdcov?",
          options: [
            {
              label: "Nie, rekreačných",
              score: 0,
            },
            {
              label: "Niekedy súťaže",
              score: 2,
            },
            {
              label: "Veľa — štartové karty sú kľúčové",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Chcete merať svoje koučovanie?",
          options: [
            {
              label: "Nie, stačí mi intuícia",
              score: 0,
            },
            {
              label: "Áno, ale nemám čas",
              score: 2,
            },
            {
              label: "Áno — koučovanie postavené na dátach",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednoduchý nástroj alebo dokonca WhatsApp zatiaľ stačí.",
          body: "Pre menej ako 5 jazdcov bez väčšieho množstva videí alebo súťaží je koučovacia aplikácia zbytočnosť. EquiSight začína zadarmo, takže to môžete vyskúšať, keď vaša prax porastie.",
          cta: "Začať zadarmo",
        },
        mid: {
          title: "EquiSight Trainer vás urobí systematicky efektívnejšími.",
          body: "Pri 5–15 kombináciách strácate každý mesiac hodiny na WhatsAppe a samostatných videách. EquiSight všetko zlúči, automaticky skenuje protokoly a zabezpečí, že jazdci si svoju spätnú väzbu vždy nájdu.",
          cta: "Vyskúšajte modul Trainer",
        },
        high: {
          title: "EquiSight je stavaný pre vašu koučovaciu škálu.",
          body: "Veľa jazdcov, video, súťaže a koučovanie postavené na dátach: presne tu sa EquiSight odlišuje. EPI + skenovanie protokolov + koňský dosiar vám dáva náskok, ktorý konkurenti nemajú.",
          cta: "Naplánujte demo pre vašu koučovaciu prax",
        },
      },
    },
    faqTitle: "Často kladené otázky o trénerských aplikáciách",
    faq: [
      {
        q: "Ktorá trénerská aplikácia je najlepšia pre koňa a jazdca?",
        a: "Na čistú komunikáciu postačí mnoho nástrojov (dokonca aj WhatsApp). Pre ciele, video analýzu, skenovanie protokolov, sledovanie súťaží a správu klientov v jednom nástroji je EquiSight najkomplexnejšie riešenie — najmä preto, že sleduje aj samotného koňa, nielen kombináciu.",
      },
      {
        q: "Dokáže EquiSight automaticky čítať súťažné protokoly?",
        a: "Áno. Nahrajte protokol KNHS alebo FEI a EquiSight extrahuje skóre podľa prvkov, komentáre rozhodcov a prepojí ich s kombináciou. Trendy vidíte naprieč viacerými súťažami.",
      },
      {
        q: "Čo je EPI (Equestrian Performance Index)?",
        a: "EPI je skóre EquiSight, ktoré premieňa viaceré súťažné výsledky na porovnateľný index výkonnosti. Vďaka tomu vidíte skutočný pokrok naprieč rôznymi triedami a rozhodcami.",
      },
      {
        q: "Môžu si jazdci sami rezervovať lekcie a platiť?",
        a: "Áno. Jazdci sa prihlásia, uvidia dostupné časy lekcií, kúpia lekciové karty a zaplatia cez iDEAL. Vy rozhodujete, čo chcete ponúkať.",
      },
      {
        q: "Funguje to aj pre inštruktora, ktorý pracuje pri jazdiareň?",
        a: "Áno. Môžete pracovať ako nezávislý tréner s vlastnými klientmi bez prepojenia s účtom jazdiarní. Klienti vám platia priamo.",
      },
      {
        q: "Môžem migrovať existujúce videá a poznámky?",
        a: "Videá môžete nahrávať po kombináciách alebo pomocou nástroja na hromadné nahrávanie. Poznámky importujte cez CSV. Aktívnym trénerom pomáhame s jednorazovou migráciou.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Sprievodcovia a pomôcky pri výbere softvéru na správu koní | EquiSight",
      description: "Všetci sprievodcovia EquiSight na jednom mieste: porovnania softvéru na správu koní, chov, jazdiareň a trénera, plus pomôcky pri výbere pre rok 2026.",
      keywords: [
        "sprievodcovia softvérom pre kone",
        "pomôcka pri výbere správy koní",
        "porovnanie softvéru pre chov koní",
        "sprievodca softvérom pre jazdiareň",
        "porovnanie aplikácií pre trénera",
      ],
    },
    hub: {
      eyebrow: "Centrum · sprievodcovia",
      breadcrumbLabel: "Sprievodcovia",
      title: "Štyri kompletní sprievodcovia na výber správneho softvéru pre kone.",
      intro: "Pre každú cieľovú skupinu podrobná pomôcka pri výbere: porovnávacie tabuľky, kritériá, príklady a interaktívny kvíz. Kliknite na sprievodcu, ktorý zodpovedá vašej situácii, alebo si najprv preštudujte prehĺbené články pod každým klastrom.",
      stats: {
        guides: "4 pomôcky pri výbere",
        articles: "15 prehĺbených článkov",
        fair: "Férové porovnanie",
      },
      readMoreCta: "Prečítajte si kompletného sprievodcu",
      relatedHeading: "Prehĺbené články",
      articlesCountSingular: "{{count}} prehĺbený článok",
      articlesCountPlural: "{{count}} prehĺbených článkov",
      articlesCountAria: "Počet článkov klastra",
      lastUpdatedPrefix: "Aktualizované",
      lastUpdatedAria: "Dátum poslednej aktualizácie tohto klastra",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Pomôcka pri výbere aplikácie na správu koní",
        blurb: "Porovnajte najznámejšie aplikácie na správu koní a zistite, ktorá sa hodí pre majiteľa, stajňu alebo chov. Vrátane férowej porovnávacej tabuľky a pomôcky na 5 otázok.",
        audience: "Pre majiteľov, prevádzkovateľov stajní a všetkých milovníkov koní, ktorí hľadajú prehľad.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Porovnanie softvéru pre chov koní",
        blurb: "Od cyklu kobýl až po vývoj žriebät: zistite, ktorý chovateľský softvér skutočne funguje pre váš počet kobýl, metódu chovu a požiadavky plemennej knihy.",
        audience: "Pre (hobby) chovateľov, žrebčíny a majiteľov žrebcov.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Pomôcka pri výbere softvéru pre jazdiareň",
        blurb: "Planovanie lekcií, evidencia jazdcov, portál pre majiteľov a fakturácia — v jednom nástroji. Porovnajte možnosti pre jazdiarne a penzionové stajne v roku 2026.",
        audience: "Pre jazdiarne, penzionové stajne a jazdecké podniky.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Pomôcka pri výbere aplikácie pre trénera",
        blurb: "Koučovací CRM, video spätná väzba, skenovanie protokolu KNHS a ciele pre každú kombináciu. Ktorá trénerská aplikácia sa hodí pre vašu koučovaciu prax?",
        audience: "Pre inštruktorov, trénerov a koučov.",
      },
    ],
    closing: {
      eyebrow: "Prečo títo sprievodcovia",
      title: "Férové porovnanie, nielen ceny.",
      body1: "Mnohé \"porovnávacie stránky\" sú v skutočnosti skryté reklamy. Naši sprievodcovia stavajú funkcie, cieľovú skupinu a konkurentov vedľa seba tak, ako by to robil nezávislý informačný zdroj. EquiSight prirodzene vyniká ako komplexné riešenie, no čítate aj úprimne, v čom sú iné aplikácie silnejšie.",
      body2: "Prehĺbené články pod každým sprievodcom odpovedajú na konkrétne otázky, ktoré vyplývajú z výberu: \"Kedy prvý ultrazvuk po inseminácii\", \"Ako automatizovať fakturáciu v jazdiárni\", \"Ako analyzovať súťažný protokol\". Žiadny marketingový balast, len prax.",
    },
    hubName: "EquiSight Sprievodcovia",
  },
  ui: {
    sectionEyebrows: {
      pains: "Prečo to bolí",
      basics: "Základy",
      criteria: "Čo ho robí dobrým?",
      comparison: "Férové porovnanie",
      why: "Rozdiel",
      beforeAfter: "Od roztrieštenia k prehľadu",
      helper: "5 otázok",
    },
    table: {
      feature: "Funkcia",
      today: "Dnes",
      withEquisight: "S EquiSight",
    },
    helper: {
      questionLabel: "Otázka {{current}} z {{total}}",
      answerPrompt: "Odpovedzte na {{count}} zostávajúcu otázku a zobrazte odporúčanie.",
      answerPromptPlural: "Odpovedzte na {{count}} zostávajúce otázky a zobrazte odporúčanie.",
      resultEyebrow: "Váš výsledok",
    },
    targetGroupsFallback: "Pre koho je to určené?",
    faqTitleFallback: "Často kladené otázky",
  },
};

export default CORNERSTONES;
